import PropTypes from "prop-types"
import { useState } from "react"

import withFilters from "areas/collection/hoc/with-filters"
import Button from "components/ui/button"
import Checkbox from "components/ui/checkbox"
import Image from "components/ui/image"

import CategoryIcon from "./category-icon"

const InternalFilterCategories = ({ filter, isMobile, setFilter }) => {
  const {
    categories,
    has_icons: hasIcons,
    unique: isUnique,
    min_display: minDisplay,
    name,
    searchable,
  } = filter

  if (!categories || categories.length < 1) return null

  const [viewMore, setViewMore] = useState(false)
  const [query, setQuery] = useState("")

  const showSearchBox = !isMobile && searchable && categories.length >= 6

  const filteredCategories = categories.filter(
    ({ name }) =>
      !showSearchBox || name.toLowerCase().includes(query.toLowerCase())
  )

  const showViewMore =
    !isMobile &&
    !viewMore &&
    minDisplay &&
    minDisplay < filteredCategories.length

  return (
    <div
      aria-label={name}
      className="pb-15 px-15 desktop:px-0 contained flex w-full flex-col items-start"
      role="group"
    >
      {showSearchBox && (
        <div className="mr-15 focus-within:border-primary mb-10 flex items-center rounded-lg border border-black p-6 focus-within:border-2">
          <Image
            alt="search"
            className="mr-5"
            height="15px"
            src={require("images/icons/search.svg")}
            width="15px"
          />
          <input
            className="text-16 leading-20 placeholder:text-grey-50 outline-hidden focus:outline-hidden w-full border-none text-black placeholder:italic"
            onChange={(e) => setQuery(e.target.value)}
            placeholder={`Search ${name}...`}
          />
        </div>
      )}
      {filteredCategories
        .slice(0, showViewMore ? minDisplay : filteredCategories.length)
        .map((category, index) => {
          return (
            <div
              className="text-18 mb-25 desktop:mb-15 w-full"
              key={`category${index}`}
            >
              <Checkbox
                checked={category.is_active_filter}
                className="w-full"
                disabled={category.disabled}
                onChange={() =>
                  setFilter(
                    category.filter_param,
                    isUnique,
                    category.belongs_to
                  )
                }
              >
                <div
                  className="flex items-center"
                  data-cy={`collection-filter-category-${category.name}-${
                    isMobile ? "mobile" : "desktop"
                  }`}
                >
                  {hasIcons && <CategoryIcon category={category} />}
                  <span className="tracking-half text-black">
                    {category.name}
                  </span>
                </div>
              </Checkbox>
            </div>
          )
        })}

      {showViewMore && (
        <Button
          className="text-14 text-black"
          data-cy={`collection-filter-category-${name
            .replace(/\s+/g, "-")
            .toLowerCase()}-view-more`}
          onClick={() => setViewMore(true)}
          text
          underline
        >
          View More
        </Button>
      )}
    </div>
  )
}

InternalFilterCategories.propTypes = {
  filter: PropTypes.object,
  isMobile: PropTypes.bool,
  setFilter: PropTypes.func,
}

const FilterCategories = withFilters(InternalFilterCategories)

export default FilterCategories
